import type { NavItem } from '../use-nav-items'
import type { TranslateFn } from './types'

export function buildImagesMenuItem(t: TranslateFn): NavItem {
  return {
    id: 'images',
    name: t('navigation.images.images'),
    link: '/graphics/',
    activePaths: ['/subscriptions/graphics/', '/crafts/', '/subscriptions/crafts/'],
    subMenuItems: [
      {
        id: 'graphics',
        name: t('navigation.images.graphics.graphics'),
        link: '/graphics/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.graphics.add_ons'),
            link: '/subscriptions/graphics/add-ons/',
          },
          {
            name: t('navigation.images.graphics.actions_and_presets'),
            link: '/subscriptions/graphics/add-ons/actions-presets/',
          },
          {
            name: t('navigation.images.graphics.ai_generated'),
            link: '/subscriptions/graphics/ai-generated/',
          },
          {
            name: t('navigation.images.graphics.backgrounds'),
            link: '/subscriptions/graphics/backgrounds/',
          },
          {
            name: t('navigation.images.graphics.cms_templates'),
            link: '/subscriptions/graphics/cms-templates/',
          },
          {
            name: t('navigation.images.graphics.coloring_books_adults'),
            link: '/subscriptions/graphics/coloring-pages-books/adults/',
          },
          {
            name: t('navigation.images.graphics.coloring_books_kids'),
            link: '/subscriptions/graphics/coloring-pages-books/kids-coloring-pages-books/',
          },
          {
            name: t('navigation.images.graphics.home_crafts'),
            link: '/subscriptions/graphics/crafts-graphics/',
          },
          {
            name: t('navigation.images.graphics.logos'),
            link: '/subscriptions/graphics/graphic-templates/logos/',
          },
          {
            name: t('navigation.images.graphics.scene_generators'),
            link: '/subscriptions/graphics/graphic-templates/scene-generators/',
          },
          {
            name: t('navigation.images.graphics.ux_and_ui_kits'),
            link: '/subscriptions/graphics/graphic-templates/ux-and-ui-kits/',
          },
          {
            name: t('navigation.images.graphics.icons'),
            link: '/subscriptions/graphics/icons/',
          },
          {
            name: t('navigation.images.graphics.illustrations'),
            link: '/subscriptions/graphics/illustrations/',
          },
          {
            name: t('navigation.images.graphics.kdp_interiors'),
            link: '/subscriptions/graphics/kdp-interiors/',
          },
          {
            name: t('navigation.images.graphics.motion_graphics'),
            link: '/subscriptions/graphics/motion-graphics/',
          },
          {
            name: t('navigation.images.graphics.objects'),
            link: '/subscriptions/graphics/objects/',
          },
          {
            name: t('navigation.images.graphics.patterns'),
            link: '/subscriptions/graphics/patterns/',
          },
          {
            name: t('navigation.images.graphics.presentation_templates'),
            link: '/subscriptions/graphics/presentation-templates/',
          },
          {
            name: t('navigation.images.graphics.product_mockups'),
            link: '/subscriptions/graphics/product-mockups/',
          },
          {
            name: t('navigation.images.graphics.t_shirt_designs'),
            link: '/subscriptions/graphics/t-shirt-designs/',
          },
          {
            name: t('navigation.images.graphics.teaching_materials'),
            link: '/subscriptions/graphics/teaching-materials/',
          },
          {
            name: t('navigation.images.graphics.textures'),
            link: '/subscriptions/graphics/textures/',
          },
          {
            name: t('navigation.images.graphics.web_elements'),
            link: '/subscriptions/graphics/web-elements/',
          },
          {
            name: t('navigation.images.graphics.web_templates'),
            link: '/subscriptions/graphics/web-templates/',
          },
          {
            name: t('navigation.images.graphics.discounted_graphics'),
            link: '/promotions/graphics/',
          },
          {
            name: t('navigation.images.graphics.browse_all'),
            link: '/graphics/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'mockups',
        name: t('navigation.images.mockups.mockups'),
        link: '/mockups/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.mockups.apparel'),
            link: '/mockups/apparel-mockups-DBtF2g0eJ/',
          },
          {
            name: t('navigation.images.mockups.beanie'),
            link: '/mockups/beanie-mockups-9MSIdWkZs/',
          },
          {
            name: t('navigation.images.mockups.blank_t_shirt'),
            link: '/mockups/blank-t-shirt-mockups-yglVUvVcV/',
          },
          {
            name: t('navigation.images.mockups.business_card'),
            link: '/mockups/business-card-mockups-nC4012r3b/',
          },
          {
            name: t('navigation.images.mockups.canvas_bag'),
            link: '/mockups/canvas-bag-mockups-QoD02UYBj/',
          },
          {
            name: t('navigation.images.mockups.cap'),
            link: '/mockups/cap-mockups-9jwJTOOGD/',
          },
          {
            name: t('navigation.images.mockups.clothing'),
            link: '/mockups/clothing-mockups-sS5SACbON/',
          },
          {
            name: t('navigation.images.mockups.computer'),
            link: '/mockups/computer-mockups-ZFRh5wnnH/',
          },
          {
            name: t('navigation.images.mockups.flyer'),
            link: '/mockups/flyer-mockups-k6R61Do5A/',
          },
          {
            name: t('navigation.images.mockups.frame'),
            link: '/mockups/frame-mockups-MwPlZWeCF/',
          },
          {
            name: t('navigation.images.mockups.hat'),
            link: '/mockups/hat-mockups-CeaN6GGy7/',
          },
          {
            name: t('navigation.images.mockups.hooded_sweatshirts'),
            link: '/mockups/hooded-sweatshirt-mockups-Hoe52CJl1/',
          },
          {
            name: t('navigation.images.mockups.hoodie'),
            link: '/mockups/hoodie-mockups-Uzm57Z5Et/',
          },
          {
            name: t('navigation.images.mockups.jumper'),
            link: '/mockups/jumper-mockups-j0qGYdNcR/',
          },
          {
            name: t('navigation.images.mockups.laptop'),
            link: '/mockups/laptop-mockups-o6qDnB6tG/',
          },
          {
            name: t('navigation.images.mockups.long_sleeve_shirt'),
            link: '/mockups/long-sleeve-shirt-mockups-ZK4cVXbJW/',
          },
          {
            name: t('navigation.images.mockups.mug'),
            link: '/mockups/mug-mockups-3jaa7NH0A/',
          },
          {
            name: t('navigation.images.mockups.phone'),
            link: '/mockups/phone-mockups-8y6oyUuO0/',
          },
          {
            name: t('navigation.images.mockups.picture_frame'),
            link: '/mockups/picture-frame-mockups-OZzf6h0QQ/',
          },
          {
            name: t('navigation.images.mockups.pillow'),
            link: '/mockups/pillow-mockups-ZDa2MESZ1/',
          },
          {
            name: t('navigation.images.mockups.polo_shirt'),
            link: '/mockups/polo-shirt-mockups-jgMefWU5a/',
          },
          {
            name: t('navigation.images.mockups.postcard'),
            link: '/mockups/postcard-mockups-cC7eBNWrW/',
          },
          {
            name: t('navigation.images.mockups.poster'),
            link: '/mockups/poster-mockups-mpqQvdqza/',
          },
          {
            name: t('navigation.images.mockups.shirt'),
            link: '/mockups/shirt-mockups-82i7MISDT/',
          },
          {
            name: t('navigation.images.mockups.shorts'),
            link: '/mockups/shorts-mockups-Q3WqhhJWY/',
          },
          {
            name: t('navigation.images.mockups.sign'),
            link: '/mockups/sign-mockups-pdnqogoZ7/',
          },
          {
            name: t('navigation.images.mockups.sticker'),
            link: '/mockups/sticker-mockups-JiSumn6va/',
          },
          {
            name: t('navigation.images.mockups.sweatshirt'),
            link: '/mockups/sweatshirt-mockups-RzXPUUe1w/',
          },
          {
            name: t('navigation.images.mockups.t_shirt'),
            link: '/mockups/t-shirt-mockups-2FASf8WyH/',
          },
          {
            name: t('navigation.images.mockups.totebag'),
            link: '/mockups/totebag-mockups-e1TinsPTw/',
          },
          {
            name: t('navigation.images.mockups.browse_all'),
            link: '/mockups/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'backgrounds',
        name: t('navigation.images.backgrounds.backgrounds'),
        link: '/backgrounds/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.backgrounds.american_flag'),
            link: '/backgrounds/american-flag-backgrounds-XOPmQWZv1/',
          },
          {
            name: t('navigation.images.backgrounds.anime'),
            link: '/backgrounds/anime-backgrounds-9AJ2XDkrQ/',
          },
          {
            name: t('navigation.images.backgrounds.black_and_gold'),
            link: '/backgrounds/black-and-gold-backgrounds-lRwHnaDKq/',
          },
          {
            name: t('navigation.images.backgrounds.blue'),
            link: '/backgrounds/blue-backgrounds-6mF1losAM/',
          },
          {
            name: t('navigation.images.backgrounds.cherry_blossom'),
            link: '/backgrounds/cherry-blossom-backgrounds-tVVwSlAJu/',
          },
          {
            name: t('navigation.images.backgrounds.christmas'),
            link: '/backgrounds/christmas-backgrounds-bOyUt3V1E/',
          },
          {
            name: t('navigation.images.backgrounds.classroom'),
            link: '/backgrounds/classroom-backgrounds-xJh1mAc1e/',
          },
          {
            name: t('navigation.images.backgrounds.colorful'),
            link: '/backgrounds/colorful-backgrounds-Rwcqa8NXM/',
          },
          {
            name: t('navigation.images.backgrounds.dinosaur'),
            link: '/backgrounds/dinosaur-backgrounds-vWJmLqPrx/',
          },
          {
            name: t('navigation.images.backgrounds.fall'),
            link: '/backgrounds/fall-backgrounds-mx2v0Ku2t/',
          },
          {
            name: t('navigation.images.backgrounds.flower'),
            link: '/backgrounds/flower-backgrounds-9IHVi7kxc/',
          },
          {
            name: t('navigation.images.backgrounds.galaxy'),
            link: '/backgrounds/galaxy-backgrounds-Pmw8pl9bj/',
          },
          {
            name: t('navigation.images.backgrounds.glitter'),
            link: '/backgrounds/glitter-backgrounds-FaWhAjDFb/',
          },
          {
            name: t('navigation.images.backgrounds.gold_glitter'),
            link: '/backgrounds/gold-glitter-backgrounds-u3488efzA/',
          },
          {
            name: t('navigation.images.backgrounds.gradient'),
            link: '/backgrounds/gradient-backgrounds-eoMy09PMk/',
          },
          {
            name: t('navigation.images.backgrounds.grey'),
            link: '/backgrounds/grey-backgrounds-9yYAxRywV/',
          },
          {
            name: t('navigation.images.backgrounds.grunge'),
            link: '/backgrounds/grunge-backgrounds-SOMtaLes1/',
          },
          {
            name: t('navigation.images.backgrounds.halloween'),
            link: '/backgrounds/halloween-backgrounds-nDfvKrq4p/',
          },
          {
            name: t('navigation.images.backgrounds.happy_birthday'),
            link: '/backgrounds/happy-birthday-backgrounds-lOd8EBhMV/',
          },
          {
            name: t('navigation.images.backgrounds.heart'),
            link: '/backgrounds/heart-backgrounds-JmZAkMuTw/',
          },
          {
            name: t('navigation.images.backgrounds.marble'),
            link: '/backgrounds/marble-backgrounds-vfdxJlBa7/',
          },
          {
            name: t('navigation.images.backgrounds.paster'),
            link: '/backgrounds/pastel-backgrounds-rviQHeFbs/',
          },
          {
            name: t('navigation.images.backgrounds.pink'),
            link: '/backgrounds/pink-backgrounds-olNOIz4ka/',
          },
          {
            name: t('navigation.images.backgrounds.psychedelic'),
            link: '/backgrounds/psychedelic-backgrounds-cTWcGzqvw/',
          },
          {
            name: t('navigation.images.backgrounds.rainbow'),
            link: '/backgrounds/rainbow-backgrounds-mEJkOXz3j/',
          },
          {
            name: t('navigation.images.backgrounds.red'),
            link: '/backgrounds/red-backgrounds-2Irkhmdmz/',
          },
          {
            name: t('navigation.images.backgrounds.sky'),
            link: '/backgrounds/sky-backgrounds-Fl6SJNxle/',
          },
          {
            name: t('navigation.images.backgrounds.snow'),
            link: '/backgrounds/snow-backgrounds-scOlBqRCF/',
          },
          {
            name: t('navigation.images.backgrounds.space'),
            link: '/backgrounds/space-backgrounds-As7wdpK5D/',
          },
          {
            name: t('navigation.images.backgrounds.spring'),
            link: '/backgrounds/spring-backgrounds-Ak7fnqjP5/',
          },
          {
            name: t('navigation.images.backgrounds.summer'),
            link: '/backgrounds/summer-backgrounds-zH06z1LRj/',
          },
          {
            name: t('navigation.images.backgrounds.thanksgiving'),
            link: '/backgrounds/thanksgiving-backgrounds-UWr27ilqD/',
          },
          {
            name: t('navigation.images.backgrounds.unicon'),
            link: '/backgrounds/unicorn-backgrounds-WxCTeTT3q/',
          },
          {
            name: t('navigation.images.backgrounds.water'),
            link: '/backgrounds/water-backgrounds-ceZnkQwve/',
          },
          {
            name: t('navigation.images.backgrounds.watercolor'),
            link: '/backgrounds/watercolor-backgrounds-E5A51z7UK/',
          },
          {
            name: t('navigation.images.backgrounds.white'),
            link: '/backgrounds/white-backgrounds-G6Iifg921/',
          },
          {
            name: t('navigation.images.backgrounds.winter'),
            link: '/backgrounds/winter-backgrounds-84cVOy2Tn/',
          },
          {
            name: t('navigation.images.backgrounds.wolf'),
            link: '/backgrounds/wolf-backgrounds-BWVvHZh3w/',
          },
          {
            name: t('navigation.images.backgrounds.wood'),
            link: '/backgrounds/wood-backgrounds-nTonplkpG/',
          },
          {
            name: t('navigation.images.backgrounds.yellow'),
            link: '/backgrounds/yellow-backgrounds-qavhCZE3q/',
          },
          {
            name: t('navigation.images.backgrounds.browse_all'),
            link: '/backgrounds/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'patterns',
        name: t('navigation.images.patterns.patterns'),
        link: '/patterns/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.patterns.90s'),
            link: '/patterns/90s-patterns-9BCk8Lhzm/',
          },
          {
            name: t('navigation.images.patterns.abstract'),
            link: '/patterns/abstract-patterns-1MSEsOWGi/',
          },
          {
            name: t('navigation.images.patterns.animal'),
            link: '/patterns/animal-patterns-ejPSSS1zW/',
          },
          {
            name: t('navigation.images.patterns.art_deco'),
            link: '/patterns/art-deco-patterns-nX02MucWM/',
          },
          {
            name: t('navigation.images.patterns.black_and_white'),
            link: '/patterns/black-and-white-patterns-FltQtLz8w/',
          },
          {
            name: t('navigation.images.patterns.butterfly_wing'),
            link: '/patterns/butterfly-wing-patterns-QLhVBCBcF/',
          },
          {
            name: t('navigation.images.patterns.camouflage'),
            link: '/patterns/camouflage-patterns-im9TtyKP9/',
          },
          {
            name: t('navigation.images.patterns.celtic'),
            link: '/patterns/celtic-patterns-fpmR3fslD/',
          },
          {
            name: t('navigation.images.patterns.chinese'),
            link: '/patterns/chinese-patterns-yzc7zMCx2/',
          },
          {
            name: t('navigation.images.patterns.christmas'),
            link: '/patterns/christmas-patterns-2qLFtye0z/',
          },
          {
            name: t('navigation.images.patterns.circle'),
            link: '/patterns/circle-patterns-MS3rfBK0e/',
          },
          {
            name: t('navigation.images.patterns.cow'),
            link: '/patterns/cow-patterns-xSH01l7DI/',
          },
          {
            name: t('navigation.images.patterns.curl'),
            link: '/patterns/curl-patterns-Oqa98SzfJ/',
          },
          {
            name: t('navigation.images.patterns.cute'),
            link: '/patterns/cute-patterns-OqqhnLOHn/',
          },
          {
            name: t('navigation.images.patterns.damascus'),
            link: '/patterns/damascus-patterns-sYs9Kw00b/',
          },
          {
            name: t('navigation.images.patterns.damask'),
            link: '/patterns/damask-patterns-XWNo5BGyt/',
          },
          {
            name: t('navigation.images.patterns.decorative'),
            link: '/patterns/decorative-patterns-ok5yLpMvs/',
          },
          {
            name: t('navigation.images.patterns.doodle'),
            link: '/patterns/doodle-patterns-OGHTDsfA4/',
          },
          {
            name: t('navigation.images.patterns.dot'),
            link: '/patterns/dot-patterns-aswGByi7H/',
          },
          {
            name: t('navigation.images.patterns.floral'),
            link: '/patterns/floral-patterns-rkaIqfiBo/',
          },
          {
            name: t('navigation.images.patterns.halloween'),
            link: '/patterns/halloween-patterns-CyRH9xQaA/',
          },
          {
            name: t('navigation.images.patterns.heart'),
            link: '/patterns/heart-patterns-wxj5EhouU/',
          },
          {
            name: t('navigation.images.patterns.ikat'),
            link: '/patterns/ikat-patterns-VouG6T3lP/',
          },
          {
            name: t('navigation.images.patterns.japanese'),
            link: '/patterns/japanese-patterns-WPjTtzwCt/',
          },
          {
            name: t('navigation.images.patterns.kimono'),
            link: '/patterns/kimono-patterns-yVFtYn4fv/',
          },
          {
            name: t('navigation.images.patterns.lace'),
            link: '/patterns/lace-patterns-fs5IoeE1C/',
          },
          {
            name: t('navigation.images.patterns.leaf'),
            link: '/patterns/leaf-patterns-2m0zRH1ly/',
          },
          {
            name: t('navigation.images.patterns.line'),
            link: '/patterns/line-patterns-4xkrc399i/',
          },
          {
            name: t('navigation.images.patterns.mosaic'),
            link: '/patterns/mosaic-patterns-4MTNhT8Bn/',
          },
          {
            name: t('navigation.images.patterns.naturalistic'),
            link: '/patterns/naturalistic-patterns-XbAaxYgJG/',
          },
          {
            name: t('navigation.images.patterns.paisley'),
            link: '/patterns/paisley-patterns-2BYW7wlaG/',
          },
          {
            name: t('navigation.images.patterns.pirate'),
            link: '/patterns/pirate-patterns-vBxFoBrLr/',
          },
          {
            name: t('navigation.images.patterns.rainbow'),
            link: '/patterns/rainbow-patterns-y9ljI7A5U/',
          },
          {
            name: t('navigation.images.patterns.retro'),
            link: '/patterns/retro-patterns-b2sdltRua/',
          },
          {
            name: t('navigation.images.patterns.rose'),
            link: '/patterns/rose-patterns-4N96RrBWs/',
          },
          {
            name: t('navigation.images.patterns.sheet'),
            link: '/patterns/sheet-patterns-EcsM3tn0i/',
          },
          {
            name: t('navigation.images.patterns.star'),
            link: '/patterns/star-patterns-syTgjltj2/',
          },
          {
            name: t('navigation.images.patterns.tile'),
            link: '/patterns/tile-patterns-gBBzv5YAB/',
          },
          {
            name: t('navigation.images.patterns.tribal'),
            link: '/patterns/tribal-patterns-UpDWhmPtY/',
          },
          {
            name: t('navigation.images.patterns.browse_all'),
            link: '/patterns/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'frames',
        name: t('navigation.images.frames.frames'),
        link: '/frames/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.frames.antique'),
            link: '/frames/antique-frame-images-Qk8m5h74U/',
          },
          {
            name: t('navigation.images.frames.artistic'),
            link: '/frames/artistic-frame-images-Xcn7sqak6/',
          },
          {
            name: t('navigation.images.frames.balloon'),
            link: '/frames/balloon-frame-images-n6QeEg8PX/',
          },
          {
            name: t('navigation.images.frames.baroque'),
            link: '/frames/baroque-frame-images-xvMn90VrQ/',
          },
          {
            name: t('navigation.images.frames.birthday'),
            link: '/frames/birthday-frame-images-3xwiZNiN3/',
          },
          {
            name: t('navigation.images.frames.black_and_white'),
            link: '/frames/black-and-white-frame-images-Dtb1NNKYT/',
          },
          {
            name: t('navigation.images.frames.black'),
            link: '/frames/black-frame-images-J8M5N3hzl/',
          },
          {
            name: t('navigation.images.frames.blue'),
            link: '/frames/blue-frame-images-fRLLdlDc2/',
          },
          {
            name: t('navigation.images.frames.butterfly'),
            link: '/frames/butterfly-frame-images-YwjCta4qg/',
          },
          {
            name: t('navigation.images.frames.cartoon'),
            link: '/frames/cartoon-frame-images-DI7DV9OPp/',
          },
          {
            name: t('navigation.images.frames.christmas'),
            link: '/frames/christmas-frame-images-SOM0rdHwo/',
          },
          {
            name: t('navigation.images.frames.circle'),
            link: '/frames/circle-frame-images-Znj9Fi5C3/',
          },
          {
            name: t('navigation.images.frames.dog'),
            link: '/frames/dog-frame-images-cArnXF8Xf/',
          },
          {
            name: t('navigation.images.frames.floral'),
            link: '/frames/floral-frame-images-5f2nuSUbS/',
          },
          {
            name: t('navigation.images.frames.flower'),
            link: '/frames/flower-frame-images-zto8crBOu/',
          },
          {
            name: t('navigation.images.frames.gold'),
            link: '/frames/gold-frame-images-xwLbF1hHo/',
          },
          {
            name: t('navigation.images.frames.gothic'),
            link: '/frames/gothic-frame-images-FGCe800WR/',
          },
          {
            name: t('navigation.images.frames.graduation'),
            link: '/frames/graduation-frame-images-T9CVjlc7h/',
          },
          {
            name: t('navigation.images.frames.browse_all'),
            link: '/frames/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'quotes',
        name: t('navigation.images.quotes.quotes'),
        link: '/quotes/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.quotes.angel_wings'),
            link: '/quotes/angel-wings-GYGfybgLN/',
          },
          {
            name: t('navigation.images.quotes.balloons'),
            link: '/quotes/balloons-QYrDcE5Ut/',
          },
          {
            name: t('navigation.images.quotes.christmas'),
            link: '/quotes/christmas-ro90cvvGE/',
          },
          {
            name: t('navigation.images.quotes.dinosaur'),
            link: '/quotes/dinosaur-m2DpdvDEn/',
          },
          {
            name: t('navigation.images.quotes.easter'),
            link: '/quotes/easter-VwdAlMZuh/',
          },
          {
            name: t('navigation.images.quotes.halloween'),
            link: '/quotes/halloween-gPl1D11F3/',
          },
          {
            name: t('navigation.images.quotes.hearts'),
            link: '/quotes/hearts-UBBHw2IpT/',
          },
          {
            name: t('navigation.images.quotes.lovers'),
            link: '/quotes/lovers-GIaMJqbdk/',
          },
          {
            name: t('navigation.images.quotes.mama'),
            link: '/quotes/mama-oE43i9xPw/',
          },
          {
            name: t('navigation.images.quotes.pumpkins'),
            link: '/quotes/pumpkins-0lfXv08by/',
          },
          {
            name: t('navigation.images.quotes.snowflakes'),
            link: '/quotes/snowflakes-9g5ZbJZbX/',
          },
          {
            name: t('navigation.images.quotes.teachers'),
            link: '/quotes/teachers-F17pAspuz/',
          },
          {
            name: t('navigation.images.quotes.tote_bag'),
            link: '/quotes/tote-bag-ZmWb6n0oR/',
          },
          {
            name: t('navigation.images.quotes.valentine'),
            link: '/quotes/valentine-GDkChNO8g/',
          },
          {
            name: t('navigation.images.quotes.browse_all'),
            link: '/quotes/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'borders_and_corners',
        name: t('navigation.images.borders_and_corners.borders_and_corners'),
        link: '/borders-and-corners/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.borders_and_corners.african'),
            link: '/borders-and-corners/african-L7pOcgi4P/',
          },
          {
            name: t('navigation.images.borders_and_corners.art_nouveau'),
            link: '/borders-and-corners/art-nouveau-No6dU4P1s/',
          },
          {
            name: t('navigation.images.borders_and_corners.asian'),
            link: '/borders-and-corners/asian-UrVKPxWG6/',
          },
          {
            name: t('navigation.images.borders_and_corners.aztec'),
            link: '/borders-and-corners/aztec-qcJy3bUMZ/',
          },
          {
            name: t('navigation.images.borders_and_corners.ball'),
            link: '/borders-and-corners/ball-gQMply2oL/',
          },
          {
            name: t('navigation.images.borders_and_corners.baseball'),
            link: '/borders-and-corners/baseball-jjPabLTfe/',
          },
          {
            name: t('navigation.images.borders_and_corners.black_and_white_leaf'),
            link: '/borders-and-corners/black-and-white-leaf-s97eAPnTe/',
          },
          {
            name: t('navigation.images.borders_and_corners.blue'),
            link: '/borders-and-corners/blue-h7XDZbPiR/',
          },
          {
            name: t('navigation.images.borders_and_corners.boho_floral'),
            link: '/borders-and-corners/boho-floral-ZlQH8UNAz/',
          },
          {
            name: t('navigation.images.borders_and_corners.breakfast'),
            link: '/borders-and-corners/breakfast-oRz7wxeNE/',
          },
          {
            name: t('navigation.images.borders_and_corners.celtic'),
            link: '/borders-and-corners/celtic-CjivifXOe/',
          },
          {
            name: t('navigation.images.borders_and_corners.chinese'),
            link: '/borders-and-corners/chinese-xYFDOSuvl/',
          },
          {
            name: t('navigation.images.borders_and_corners.egyptian'),
            link: '/borders-and-corners/egyptian-kT0OJvnle/',
          },
          {
            name: t('navigation.images.borders_and_corners.elephant'),
            link: '/borders-and-corners/elephant-BxeRp1Pik/',
          },
          {
            name: t('navigation.images.borders_and_corners.fall_leaves'),
            link: '/borders-and-corners/fall-leaves-PCe6Ax2v7/',
          },
          {
            name: t('navigation.images.borders_and_corners.food'),
            link: '/borders-and-corners/food-BOd8nJ85O/',
          },
          {
            name: t('navigation.images.borders_and_corners.grass'),
            link: '/borders-and-corners/grass-WGba4WfTH/',
          },
          {
            name: t('navigation.images.borders_and_corners.green_leaves'),
            link: '/borders-and-corners/green-leaves-pyZ53UTec/',
          },
          {
            name: t('navigation.images.borders_and_corners.indian'),
            link: '/borders-and-corners/indian-M40sMui2R/',
          },
          {
            name: t('navigation.images.borders_and_corners.lilac'),
            link: '/borders-and-corners/lilac-xZRoKUrlY/',
          },
          {
            name: t('navigation.images.borders_and_corners.mexican_flowers'),
            link: '/borders-and-corners/mexican-flowers-WxXqFFuVs/',
          },
          {
            name: t('navigation.images.borders_and_corners.pampas_grass'),
            link: '/borders-and-corners/pampas-grass-vtgN3QjYG/',
          },
          {
            name: t('navigation.images.borders_and_corners.picnic'),
            link: '/borders-and-corners/picnic-F2vZO3CZe/',
          },
          {
            name: t('navigation.images.borders_and_corners.plant'),
            link: '/borders-and-corners/plant-4v0edcZqy/',
          },
          {
            name: t('navigation.images.borders_and_corners.poinsettia'),
            link: '/borders-and-corners/poinsettia-d3V4m9l9k/',
          },
          {
            name: t('navigation.images.borders_and_corners.sea_life'),
            link: '/borders-and-corners/sea-life-ubbnlBu4w/',
          },
          {
            name: t('navigation.images.borders_and_corners.snowflake'),
            link: '/borders-and-corners/snowflake-NqXZPJt6w/',
          },
          {
            name: t('navigation.images.borders_and_corners.succulent'),
            link: '/borders-and-corners/succulent-RdjcBX554/',
          },
          {
            name: t('navigation.images.borders_and_corners.sunflower'),
            link: '/borders-and-corners/sunflower-N7Scz9WXf/',
          },
          {
            name: t('navigation.images.borders_and_corners.tree_branch'),
            link: '/borders-and-corners/tree-branch-UEg8ScPAu/',
          },
          {
            name: t('navigation.images.borders_and_corners.tribal'),
            link: '/borders-and-corners/tribal-pbzTtRQMR/',
          },
          {
            name: t('navigation.images.borders_and_corners.tropical_leaves'),
            link: '/borders-and-corners/tropical-leaves-CehKv0Km5/',
          },
          {
            name: t('navigation.images.borders_and_corners.watercolor_leaves'),
            link: '/borders-and-corners/watercolor-leaves-33ui737sr/',
          },
          {
            name: t('navigation.images.borders_and_corners.browse_all'),
            link: '/borders-and-corners/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'coloring_pages',
        name: t('navigation.images.coloring_pages.coloring_pages'),
        link: '/coloring-pages/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.coloring_pages.animal'),
            link: '/coloring-pages/animal-EaWBnJge8/',
          },
          {
            name: t('navigation.images.coloring_pages.cats'),
            link: '/coloring-pages/cats-tgafQk4aP/',
          },
          {
            name: t('navigation.images.coloring_pages.christmas'),
            link: '/coloring-pages/christmas-J6JMRZUsA/',
          },
          {
            name: t('navigation.images.coloring_pages.dog'),
            link: '/coloring-pages/dog-mtcpnQ5te/',
          },
          {
            name: t('navigation.images.coloring_pages.dolphin'),
            link: '/coloring-pages/dolphin-fbKhX8K8z/',
          },
          {
            name: t('navigation.images.coloring_pages.easter'),
            link: '/coloring-pages/easter-lnGBRvELU/',
          },
          {
            name: t('navigation.images.coloring_pages.fairy'),
            link: '/coloring-pages/fairy-fOfIytBck/',
          },
          {
            name: t('navigation.images.coloring_pages.fall'),
            link: '/coloring-pages/fall-dbswUUEzI/',
          },
          {
            name: t('navigation.images.coloring_pages.halloween'),
            link: '/coloring-pages/halloween-2pKR7Ec0W/',
          },
          {
            name: t('navigation.images.coloring_pages.heart'),
            link: '/coloring-pages/heart-DVl6vs9zF/',
          },
          {
            name: t('navigation.images.coloring_pages.st_patricks_day'),
            link: '/coloring-pages/st-patricks-day-zYQTh3iPg/',
          },
          {
            name: t('navigation.images.coloring_pages.summer'),
            link: '/coloring-pages/summer-mBThJgsKV/',
          },
          {
            name: t('navigation.images.coloring_pages.super_hero'),
            link: '/coloring-pages/super-hero-FxU7MICse/',
          },
          {
            name: t('navigation.images.coloring_pages.turkey'),
            link: '/coloring-pages/turkey-EVQeHTMZc/',
          },
          {
            name: t('navigation.images.coloring_pages.puppies'),
            link: '/coloring-pages/puppies-fyJXAPs7k/',
          },
          {
            name: t('navigation.images.coloring_pages.unicorn'),
            link: '/coloring-pages/unicorn-Rf4mBoh89/',
          },
          {
            name: t('navigation.images.coloring_pages.winter'),
            link: '/coloring-pages/winter-w1IalPPiM/',
          },
          {
            name: t('navigation.images.coloring_pages.browse_all'),
            link: '/coloring-pages/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'crafts',
        name: t('navigation.crafts.crafts'),
        link: '/crafts/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.crafts.craft_designs'),
            link: '/crafts/',
          },
          {
            name: t('navigation.crafts.deals'),
            link: '/the-craft-club/deals/',
          },
          {
            name: t('navigation.crafts.halloween'),
            link: '/subscriptions/crafts/halloween/',
          },
          {
            name: t('navigation.crafts.thanksgiving'),
            link: '/subscriptions/crafts/thanksgiving/',
          },
          {
            name: t('navigation.crafts.kids'),
            link: '/subscriptions/crafts/kids/',
          },
          {
            name: t('navigation.crafts.fall'),
            link: '/subscriptions/crafts/fall/',
          },
          {
            name: t('navigation.crafts.easter'),
            link: '/subscriptions/crafts/easter/',
          },
          {
            name: t('navigation.crafts.spring'),
            link: '/subscriptions/crafts/spring/',
          },
          {
            name: t('navigation.graphics.browse_all'),
            link: '/crafts/',
          },
          {
            name: t('navigation.crafts.view_all'),
            link: '/crafts/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'photos',
        name: t('navigation.images.photos.photos'),
        link: '/stockphotos/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.images.photos.animals'),
            link: '/stockphotos/animals-stockphotos-6qmKQdW18/',
          },
          {
            name: t('navigation.images.photos.arts'),
            link: '/stockphotos/arts-stockphotos-lvf9Q2D73/',
          },
          {
            name: t('navigation.images.photos.backgrounds'),
            link: '/stockphotos/background-stockphotos-d4cML8m8z/',
          },
          {
            name: t('navigation.images.photos.fashion'),
            link: '/stockphotos/beauty-stockphotos-7KamZYbDP/',
          },
          {
            name: t('navigation.images.photos.buildings'),
            link: '/stockphotos/buildings-stockphotos-pvp8G5tYB/',
          },
          {
            name: t('navigation.images.photos.food'),
            link: '/stockphotos/food-stockphotos-IOBAvVmbi/',
          },
          {
            name: t('navigation.images.photos.holidays'),
            link: '/stockphotos/holidays-stockphotos-3fjri68Yz/',
          },
          {
            name: t('navigation.images.photos.miscellaneous'),
            link: '/stockphotos/miscellaneous-stockphotos-PgedJUkWC/',
          },
          {
            name: t('navigation.images.photos.nature'),
            link: '/stockphotos/nature-stockphotos-ndT9Fhx5o/',
          },
          {
            name: t('navigation.images.photos.people'),
            link: '/stockphotos/people-stockphotos-xHvls6LP9/',
          },
          {
            name: t('navigation.images.photos.religion'),
            link: '/stockphotos/religion-stockphotos-Mc4AFHy2H/',
          },
          {
            name: t('navigation.images.photos.seasons'),
            link: '/stockphotos/seasons-stockphotos-T9cJ9xZlv/',
          },
          {
            name: t('navigation.images.photos.sports'),
            link: '/stockphotos/sports-stockphotos-WVoeg9rNe/',
          },
          {
            name: t('navigation.images.photos.browse_all'),
            link: '/stockphotos/',
            isFootOption: true,
          },
        ],
      },
    ],
  }
}
